let env = {};

env.baseURL = 'https://api.app.invitee.com.br/api/v1/';
env.normalURL = 'https://api.app.invitee.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js